import React, { useState } from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  Typography,
  Avatar,
  Paper,
  Divider,
  useTheme,
  Collapse,
  // Button,
} from '@mui/material';
import {
  // Person,
  // Notifications,
  // Settings,
  // Group,
  // Feed,
  // ConnectWithoutContact,
  // NewspaperTwoTone,
  // EventTwoTone,
  QuizTwoTone,
  // SchoolTwoTone,
  // WorkTwoTone,
  // VideoLibraryTwoTone,
  // BusinessTwoTone,
  // MenuBookTwoTone,
  // EmojiEventsTwoTone,
  // GroupsTwoTone,
  ArticleTwoTone,
  CategoryTwoTone,
  // DomainTwoTone,
  ForumTwoTone,
  AssignmentTwoTone,
  GroupTwoTone,
  FolderTwoTone,
  MenuBookTwoTone,
  EventTwoTone,
  AssessmentOutlined,
  NewspaperOutlined,
  StorefrontTwoTone,
  BusinessTwoTone,
  ManageAccountsTwoTone,
  ExpandLess,
  ExpandMore,
  InventoryTwoTone,
  TopicTwoTone,
  RssFeed,
  EventNote,
  Inventory2,
  School,
  // HelpOutline,
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useViewPort, useAuth } from '@/hooks';
import { USER_ROLES } from '@/constants/app';
import { Tour, type TourStep } from '@/components';

interface NavigationItem {
  id: string;
  label: string;
  icon: React.ReactElement;
  path?: string;
  roles?: string[];
  children?: NavigationItem[];
}

const homeItem: NavigationItem = {
  id: 'Talky',
  label: 'Home',
  icon: <ForumTwoTone />,
  path: '/talky',
  roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMINISTRATOR, USER_ROLES.STAFF, USER_ROLES.USER, USER_ROLES.PARENTS],
};

const appFeatureItems: NavigationItem[] = [

  {
    id: 'assessment',
    label: 'HR Skill Assessment',
    icon: <QuizTwoTone />,
    path: '/assessment',
    roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMINISTRATOR, USER_ROLES.STAFF, USER_ROLES.USER, USER_ROLES.PARENTS],
  },
    {
    id: 'admin-knowledge-base',
    label: 'Documents Vault',
    icon: <MenuBookTwoTone />,
    path: '/admin/documents-vault',
    roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMINISTRATOR],
  },
  {
    id: 'products-services',
    label: 'Products & Services',
    icon: <InventoryTwoTone />,
    path: '/products-services',
    roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMINISTRATOR, USER_ROLES.STAFF, USER_ROLES.USER, USER_ROLES.PARENTS],
  },
  {
    id: 'courses',
    label: 'Courses',
    icon: <School />,
    path: '/courses',
    roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMINISTRATOR, USER_ROLES.STAFF, USER_ROLES.USER, USER_ROLES.PARENTS],
  },
    {
    id: 'explore-businesses',
    label: 'Explore Businesses',
    icon: <BusinessTwoTone />,
    path: '/businesses',
    roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMINISTRATOR, USER_ROLES.STAFF, USER_ROLES.USER, USER_ROLES.PARENTS],
  },
    {
    id: 'all-events',
    label: 'Events',
    icon: <EventTwoTone />,
    path: '/events',
    roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMINISTRATOR, USER_ROLES.STAFF, USER_ROLES.USER, USER_ROLES.PARENTS],
  },

  {
    id: 'news',
    label: 'News',
    icon: <NewspaperOutlined />,
    path: '/news',
    roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMINISTRATOR],
  },
  {
    id: 'document-explorer',
    label: 'Document Explorer',
    icon: <TopicTwoTone />,
    path: '/documents',
    roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMINISTRATOR, USER_ROLES.STAFF, USER_ROLES.USER, USER_ROLES.PARENTS],
  },
  {
    id: 'job-categories',
    label: 'Job Categories',
    icon: <CategoryTwoTone />,
    path: '/job-categories',
    roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMINISTRATOR],
  },
  {
    id: 'admin-users',
    label: 'Users',
    icon: <GroupTwoTone />,
    path: '/admin/users',
    roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMINISTRATOR],
  },
  {
    id: 'admin-folders',
    label: 'Folders',
    icon: <FolderTwoTone />,
    path: '/admin/folders',
    roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMINISTRATOR],
  },

  {
    id: 'admin-manage-business',
    label: 'Manage Business',
    icon: <ManageAccountsTwoTone />,
    path: '/admin/manage-business',
    roles: [USER_ROLES.SUPER_ADMIN],
  },
  {
    id: 'reports',
    label: 'Reports',
    icon: <AssessmentOutlined />,
    roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMINISTRATOR],
    children: [
      {
        id: 'reports-overview',
        label: 'Feed Reports',
        icon: <RssFeed />,
        path: '/reports',
        roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMINISTRATOR],
      },
      {
        id: 'event-reports',
        label: 'Event Reports',
        icon: <EventNote />,
        path: '/admin/event-reports',
      roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMINISTRATOR],
      },
      {
        id: 'service-product-reports',
        label: 'Service/Product Reports',
        icon: <Inventory2 />,
        path: '/admin/service-product-reports',
        roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMINISTRATOR],
      },
      {
        id: 'course-reports',
        label: 'Course Reports',
        icon: <School />,
        path: '/admin/course-reports',
        roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMINISTRATOR],
      },
    ],
  },
];

const myFeatureItems: NavigationItem[] = [
  {
    id: 'my-posts',
    label: 'My Talky',
    icon: <ArticleTwoTone />,
    path: '/my-talky',
    roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMINISTRATOR, USER_ROLES.STAFF, USER_ROLES.USER, USER_ROLES.PARENTS],
  },
  {
    id: 'my-events',
    label: 'My Events',
    icon: <EventTwoTone />,
    path: '/my-events',
    roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMINISTRATOR, USER_ROLES.STAFF, USER_ROLES.USER, USER_ROLES.PARENTS],
  },
  {
    id: 'my-business',
    label: 'My Business',
    icon: <StorefrontTwoTone />,
    path: '/my-business',
    roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMINISTRATOR, USER_ROLES.STAFF, USER_ROLES.USER, USER_ROLES.PARENTS],
  },
  {
    id: 'my-applications',
    label: 'My Applications',
    icon: <AssignmentTwoTone />,
    path: '/my-applications',
    roles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMINISTRATOR, USER_ROLES.STAFF, USER_ROLES.USER, USER_ROLES.PARENTS],
  },
];

interface SocialSidebarProps {
  mobileOpen: boolean;
  onMobileClose: () => void;
  width: number;
}

export const SocialSidebar: React.FC<SocialSidebarProps> = ({
  mobileOpen,
  onMobileClose,
  width,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const { isMobile } = useViewPort();
  const { user } = useAuth();
  
  const [isCollapsed, _setIsCollapsed] = useState(true);
  const [isHovered, _] = useState(true);
  const [expandedItems, setExpandedItems] = useState<string[]>([]);
  const [tourOpen, setTourOpen] = useState(false);

  const collapsedWidth = 80;
  const currentWidth = !isMobile && isCollapsed && !isHovered ? collapsedWidth : width;

  // Tour steps for sidebar navigation
  const sidebarTourSteps: TourStep[] = [
    {
      title: 'Sidebar Navigation',
      content: 'This sidebar helps you navigate through different sections of HRTalky. Let me show you around!',
    },
    {
      target: '[data-tour="profile-card"]',
      title: 'Your Profile Card',
      content: 'View your profile stats including posts, followers, and following. Click on any stat to navigate.',
      placement: 'right',
    },
    {
      target: '[data-tour="nav-home"]',
      title: 'Home Feed',
      content: 'Access your personalized home feed with the latest posts and updates from your network.',
      placement: 'right',
    },
    {
      target: '[data-tour="nav-events"]',
      title: 'Events',
      content: 'Browse all events happening in the HR community or manage your own events.',
      placement: 'right',
    },
    {
      target: '[data-tour="nav-business"]',
      title: 'Business',
      content: 'Manage your businesses or explore other businesses on the platform.',
      placement: 'right',
    },
    {
      target: '[data-tour="nav-posts"]',
      title: 'My Talky',
      content: 'View and manage all your posts in one convenient place.',
      placement: 'right',
    },
    {
      target: '[data-tour="nav-applications"]',
      title: 'My Applications',
      content: 'Track all your job applications and their current status.',
      placement: 'right',
    },
    {
      target: '[data-tour="nav-assessment"]',
      title: 'HR Skill Assessment',
      content: 'Take skill assessments to showcase your expertise and stand out to employers.',
      placement: 'right',
    },
  ];

  const handleNavigate = (path: string) => {
    navigate(path);
    if (isMobile) {
      onMobileClose();
    }
  };

  const handleToggleExpanded = (itemId: string) => {
    setExpandedItems(prev =>
      prev.includes(itemId)
        ? prev.filter(id => id !== itemId)
        : [...prev, itemId]
    );
  };

  const hasAccess = (roles?: string[]): boolean => {
    if (!roles || roles.length === 0) return true;
    return user?.role ? roles.includes(user.role) : false;
  };

  const isActiveRoute = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  // const handleStartTour = () => {
  //   setTourOpen(true);
  // };

  const handleCloseTour = () => {
    setTourOpen(false);
  };

  const renderMenuItem = (item: NavigationItem, level = 0): React.ReactNode => {
    if (!hasAccess(item.roles)) return null;

    const isExpanded = expandedItems.includes(item.id);
    const hasChildren = item.children && item.children.length > 0;
    const isActive = item.path ? isActiveRoute(item.path) : false;

    // Map item IDs to data-tour attributes (using data-tour instead of data-intro to avoid auto-start)
    const getDataTour = (id: string): string | undefined => {
      const tourMap: Record<string, string> = {
        'Talky': 'nav-home',
        'all-events': 'nav-events',
        'explore-businesses': 'nav-business',
        'my-posts': 'nav-posts',
        'my-applications': 'nav-applications',
        'assessment': 'nav-assessment',
      };
      return tourMap[id];
    };

    const handleClick = () => {
      if (hasChildren) {
        handleToggleExpanded(item.id);
      } else if (item.path) {
        handleNavigate(item.path);
      }
    };

    return (
      <React.Fragment key={item.id}>
        <ListItem disablePadding sx={{ mb: 0.5 }}>
          <ListItemButton
            onClick={handleClick}
            data-tour={getDataTour(item.id)}
            sx={{
              borderRadius: 1,
              py: 1,
              px: !isMobile && isCollapsed && !isHovered ? 1 : level > 0 ? 3 : 1.5,
              transition: 'all 0.15s ease',
              bgcolor: isActive ? (theme.palette.mode === 'light' ? '#e7f3ff' : 'rgba(10, 102, 194, 0.2)') : 'transparent',
              borderLeft: isActive ? '3px solid #0a66c2' : '3px solid transparent',
              justifyContent: !isMobile && isCollapsed && !isHovered ? 'center' : 'flex-start',
              '&:hover': {
                bgcolor: theme.palette.mode === 'light' ? '#f3f2ef' : 'action.hover',
              },
              '& .MuiListItemIcon-root': {
                color: isActive ? '#0a66c2' : 'text.secondary',
                minWidth: !isMobile && isCollapsed && !isHovered ? 'auto' : 36,
              },
              '& .MuiListItemText-primary': {
                fontWeight: isActive ? 600 : 400,
                color: isActive ? '#0a66c2' : 'text.primary',
              },
            }}
          >
            <ListItemIcon sx={{
              minWidth: !isMobile && isCollapsed && !isHovered ? 'auto' : 36,
              '& svg': {
                fontSize: 20,
              }
            }}>
              {item.icon}
            </ListItemIcon>
            {(!(!isMobile && isCollapsed) || isHovered) && (
              <>
                <ListItemText
                  primary={item.label}
                  slotProps={{
                    primary: {
                      sx: {
                        fontSize: '0.875rem',
                        color: 'inherit',
                      }
                    }
                  }}
                />
                {hasChildren && (
                  isExpanded ? <ExpandLess sx={{ fontSize: 20 }} /> : <ExpandMore sx={{ fontSize: 20 }} />
                )}
              </>
            )}
          </ListItemButton>
        </ListItem>
        {hasChildren && (
          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {item.children!.map(child => renderMenuItem(child, level + 1))}
            </List>
          </Collapse>
        )}
      </React.Fragment>
    );
  };

  const drawerContent = (
    <Box
      // onMouseEnter={() => setIsHovered(true)}
      // onMouseLeave={() => setIsHovered(false)}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.paper',
        borderRadius: 2,
        border: `1px solid ${theme.palette.divider}`,
        overflow: 'hidden',
        transition: 'all 0.3s ease-in-out',
      }}
    >
      {/* Profile Avatar for Collapsed Mode */}
      {!isMobile && isCollapsed && !isHovered && (
        <Box
          sx={{
            flexShrink: 0,
            px: 1,
            pt: 3,
            pb: 2,
            display: 'flex',
            justifyContent: 'center',
            transition: 'all 0.3s ease-in-out',
          }}
        >
          {user?.isLookingForJob ? (
            <Box sx={{ position: 'relative', display: 'inline-block' }}>
              <Box
                sx={{
                  position: 'absolute',
                  top: -4,
                  left: -4,
                  right: -4,
                  bottom: -4,
                  borderRadius: '50%',
                  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
                  padding: '4px',
                }}
              >
                <Box
                  sx={{
                    width: '100%',
                    height: '100%',
                    borderRadius: '50%',
                    background: theme.palette.background.paper,
                  }}
                />
              </Box>
              <Avatar
                sx={{
                  width: 44,
                  height: 44,
                  bgcolor: 'primary.main',
                  fontSize: '1.2rem',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  position: 'relative',
                  zIndex: 1,
                  '&:hover': {
                    transform: 'scale(1.1)',
                    boxShadow: theme.shadows[4],
                  },
                  transition: 'all 0.2s ease',
                }}
                src={user?.profilePicture?.url}
              >
                {user?.name?.charAt(0).toUpperCase() || 'U'}
              </Avatar>
              <Box
                sx={{
                  position: 'absolute',
                  bottom: -8,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
                  color: 'white',
                  fontSize: '6px',
                  fontWeight: 700,
                  padding: '2px 8px',
                  borderRadius: '10px',
                  whiteSpace: 'nowrap',
                  zIndex: 2,
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                }}
              >
                OPEN TO WORK
              </Box>
            </Box>
          ) : user?.profilePicture?.url ? (
            <Avatar
              sx={{
                width: 48,
                height: 48,
                bgcolor: 'primary.main',
                fontSize: '1.2rem',
                fontWeight: 'bold',
                cursor: 'pointer',
                '&:hover': {
                  transform: 'scale(1.1)',
                  boxShadow: theme.shadows[4],
                },
                transition: 'all 0.2s ease',
              }}
              src={user?.profilePicture?.url}
            />
          ) : (
            <Avatar
              sx={{
                width: 48,
                height: 48,
                bgcolor: 'primary.main',
                fontSize: '1.2rem',
                fontWeight: 'bold',
                cursor: 'pointer',
                '&:hover': {
                  transform: 'scale(1.1)',
                  boxShadow: theme.shadows[4],
                },
                transition: 'all 0.2s ease',
              }}
            >
              {user?.name?.charAt(0).toUpperCase() || 'U'}
            </Avatar>
          )}
        </Box>
      )}

      {/* User Profile Section - Fixed at top */}
      <Box
        sx={{
          flexShrink: 0,
          px: 2,
          pt: 3,
          pb: 2,
          display: !isMobile && isCollapsed && !isHovered ? 'none' : 'block',
          transition: 'all 0.3s ease-in-out',
        }}
      >
        <Paper
          elevation={0}
          data-tour="profile-card"
          sx={{
            p: 2,
            borderRadius: 2,
            border: `1px solid ${theme.palette.divider}`,
            bgcolor: 'background.paper',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
        {/* Background Banner */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: 60,
            backgroundImage: 'url(https://s3.hrtalky.com/hr-api-files/1764846884795-498a30cdf23c8915-9.png?w=1200&q=80)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderRadius: '8px 8px 0 0',
          }}
        />
        
        <Box sx={{ position: 'relative', zIndex: 1, pt: 2, textAlign: 'center' }}>
          {user?.isLookingForJob ? (
            <Box sx={{ position: 'relative', display: 'inline-block', mb: 1 }}>
              <Box
                sx={{
                  position: 'absolute',
                  top: -3,
                  left: -3,
                  right: -3,
                  bottom: -3,
                  borderRadius: '50%',
                  background: `linear-gradient(135deg, #0a66c2 0%, #004182 100%)`,
                  padding: '3px',
                }}
              >
                <Box
                  sx={{
                    width: '100%',
                    height: '100%',
                    borderRadius: '50%',
                    background: theme.palette.background.paper,
                  }}
                />
              </Box>
              <Avatar
                sx={{
                  width: 56,
                  height: 56,
                  bgcolor: '#0a66c2',
                  fontSize: '1.25rem',
                  fontWeight: 'bold',
                  position: 'relative',
                  zIndex: 1,
                  border: `3px solid ${theme.palette.background.paper}`,
                }}
                src={user?.profilePicture?.url}
              >
                {user?.name.charAt(0).toUpperCase()}
              </Avatar>
              <Box
                sx={{
                  position: 'absolute',
                  bottom: -6,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  background: '#0a66c2',
                  color: 'white',
                  fontSize: '7px',
                  fontWeight: 700,
                  padding: '2px 8px',
                  borderRadius: '10px',
                  whiteSpace: 'nowrap',
                  zIndex: 2,
                }}
              >
                #OpenToWork
              </Box>
            </Box>
          ) : (
            <Avatar
              sx={{
                width: 56,
                height: 56,
                mb: 1,
                mx: 'auto',
                bgcolor: '#0a66c2',
                fontSize: '1.25rem',
                fontWeight: 'bold',
                border: `3px solid ${theme.palette.background.paper}`,
              }}
              src={user?.profilePicture?.url}
            >
              {user?.name?.charAt(0).toUpperCase()}
            </Avatar>
          )}
          <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'text.primary', mt: user?.isLookingForJob ? 2 : 0 }}>
            {user?.name || 'User Name'}
          </Typography>

          <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mb: 1.5 }}>
           {(user?.aboutMe || '').length > 60
              ? (user?.aboutMe)?.slice(0, 60) + '...'
              : user?.aboutMe || (typeof user?.designation === 'string' ? user.designation : '') || ''}
          </Typography>

          <Divider sx={{ my: 1.5 }} />

          <Box sx={{ display: 'flex', justifyContent: 'space-around' }}>
            <Box
              onClick={() => navigate('/my-talky')}
              sx={{
                textAlign: 'center',
                cursor: 'pointer',
                p: 0.5,
                borderRadius: 1,
                '&:hover': { bgcolor: 'action.hover' },
              }}
            >
              <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#0a66c2' }}>
                {user?.stats?.feedCount || 0}
              </Typography>
              <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.7rem' }}>
                Posts
              </Typography>
            </Box>
            <Box
              onClick={() => navigate('/network?tab=0')}
              sx={{
                textAlign: 'center',
                cursor: 'pointer',
                p: 0.5,
                borderRadius: 1,
                '&:hover': { bgcolor: 'action.hover' },
              }}
            >
              <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#0a66c2' }}>
                {user?.stats?.followersCount || 0}
              </Typography>
              <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.7rem' }}>
                Followers
              </Typography>
            </Box>
            <Box
              onClick={() => navigate('/network?tab=1')}
              sx={{
                textAlign: 'center',
                cursor: 'pointer',
                p: 0.5,
                borderRadius: 1,
                '&:hover': { bgcolor: 'action.hover' },
              }}
            >
              <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#0a66c2' }}>
                {user?.stats?.followingCount || 0}
              </Typography>
              <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.7rem' }}>
                Following
              </Typography>
            </Box>
          </Box>
        </Box>
        </Paper>
      </Box>

      {/* Navigation Menu - Scrollable */}
      <Box
        sx={{
          flex: 1,
          overflow: 'auto',
          px: 2,
          mt: !isMobile && isCollapsed && !isHovered ? 0 : 0,
          '&::-webkit-scrollbar': {
            width: '6px',
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent',
          },
          '&::-webkit-scrollbar-thumb': {
            background: theme.palette.divider,
            borderRadius: '3px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: theme.palette.text.secondary,
          },
        }}
      >
        <List sx={{ px: 0 }}>
          {renderMenuItem(homeItem)}
          {!isMobile && isCollapsed && !isHovered && <Divider sx={{ my: 1 }} />}
          {(!(!isMobile && isCollapsed) || isHovered) && (
            <Typography
              variant="overline"
              sx={{
                display: 'block',
                px: 1.5,
                pt: 1,
                pb: 0.5,
                color: 'text.secondary',
                fontSize: '0.7rem',
                fontWeight: 700,
                letterSpacing: '0.08em',
              }}
            >
              My Hub
            </Typography>
          )}
          {myFeatureItems.map((item) => renderMenuItem(item))}
          {!isMobile && isCollapsed && !isHovered && <Divider sx={{ my: 1 }} />}
          {(!(!isMobile && isCollapsed) || isHovered) && (
            <Typography
              variant="overline"
              sx={{
                display: 'block',
                px: 1.5,
                pt: 2,
                pb: 0.5,
                color: 'text.secondary',
                fontSize: '0.7rem',
                fontWeight: 700,
                letterSpacing: '0.08em',
              }}
            >
              HRTalky Features
            </Typography>
          )}
          {appFeatureItems.map((item) => renderMenuItem(item))}
        </List>
      </Box>

      {/* Footer - Fixed at bottom */}
      <Box
        sx={{
          flexShrink: 0,
          px: 2,
          pb: 2,
          pt: 1,
          display: !isMobile && isCollapsed && !isHovered ? 'none' : 'block',
          transition: 'all 0.3s ease-in-out',
        }}
      >
        <Box sx={{ textAlign: 'center' }}>
          {/* Help Tour Button */}
          {/* <Button
            variant="outlined"
            size="small"
            startIcon={<HelpOutline />}
            onClick={handleStartTour}
            fullWidth
            sx={{
              mb: 1.5,
              textTransform: 'none',
              borderColor: 'divider',
              color: 'text.secondary',
              '&:hover': {
                borderColor: 'primary.main',
                bgcolor: 'action.hover',
                color: 'primary.main',
              },
            }}
          >
            Take a Tour
          </Button> */}
          <Box sx={{ display: 'flex', gap: 1.5, justifyContent: 'center', flexWrap: 'wrap' }}>
            {['About', 'Settings', 'Support'].map((link) => (
              <Typography
                key={link}
                variant="caption"
                sx={{
                  color: 'text.secondary',
                  cursor: 'pointer',
                  fontSize: '0.7rem',
                  '&:hover': { color: '#0a66c2', textDecoration: 'underline' },
                }}
              >
                {link}
              </Typography>
            ))}
          </Box>
          <Typography variant="caption" sx={{ color: 'text.disabled', mt: 0.5, display: 'block', fontSize: '0.65rem' }}>
            HRTalky © 2025
          </Typography>
        </Box>
      </Box>
    </Box>
  );

  if (isMobile) {
    return (
      <>
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={onMobileClose}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 2,
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width,
              border: 'none',
            },
          }}
        >
          {drawerContent}
        </Drawer>
        <Tour
          steps={sidebarTourSteps}
          open={tourOpen}
          onClose={handleCloseTour}
        />
      </>
    );
  }

  return (
    <>
      <Box
        sx={{
          position: 'sticky',
          top: 64, // Header height
          height: `calc(100vh - 72px)`,
          flexShrink: 0,
          width: currentWidth,
          zIndex: theme.zIndex.drawer,
          bgcolor: 'background.default',
          overflow: 'hidden',
          transition: 'width 0.3s ease-in-out',
        }}
      >
        {drawerContent}
      </Box>
      <Tour
        steps={sidebarTourSteps}
        open={tourOpen}
        onClose={handleCloseTour}
      />
    </>
  );
};